import classNames from '@sindresorhus/class-names';
import {FooterLeftSideBlock} from '@ui-kit/src/Footer/Footer.types';
import {footerTestId} from '@ui-kit/src/Footer/footerTestId';

import styles from './LeftSideBlock.module.scss';

interface Props {
  leftSideContent: FooterLeftSideBlock;
  lowLinks: boolean;
}

export const LeftSideBlock = ({leftSideContent, lowLinks}: Props) => {
  return (
    <>
      <div className={styles.absoluteBlock}>
        <img
          className={styles.logo}
          src={leftSideContent.rustoreLogoHref}
          alt="Лого RuStore"
          loading="lazy"
        />
        {leftSideContent.underLogoContent}
      </div>
      <div
        className={styles.qrCodeBlock}
        data-testid={footerTestId.footerQrCode}
      >
        <img
          src={leftSideContent.qrCodeHref}
          alt="QR-код для скачивания"
          className={styles.qrCode}
          loading="lazy"
        />
        <div
          className={styles.qrCodeDescription}
          dangerouslySetInnerHTML={leftSideContent.qrCodeDescription}
        />
      </div>
      <div className={styles.socialLinks}>
        {leftSideContent.socialLinks?.map(
          ({title, logoHref, logoAlt, ...linkProps}) => (
            <a
              {...linkProps}
              key={linkProps.href}
              className={styles.socialLink}
              data-testid={footerTestId.footerSocialLink}
            >
              <img
                className={styles.socialLink__icon}
                src={logoHref}
                alt={logoAlt ?? linkProps.href}
                loading="lazy"
              />
            </a>
          ),
        )}
      </div>
      <div
        className={classNames(styles.copyRight, {
          [styles.copyRight__additionalMt]: lowLinks,
        })}
        data-testid={footerTestId.footerCopyright}
        dangerouslySetInnerHTML={leftSideContent.copyright}
      />
      <div className={styles.bottomContent}>
        {leftSideContent.bottomContent}
      </div>
    </>
  );
};
